<p-dialog
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '560px', maxWidth: '92vw' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [closeOnEscape]="true"
  [blockScroll]="true"
  [appendTo]="'body'"
  maskStyleClass="crm-dialog-mask"
  styleClass="complaint-modal">
  <ng-template pTemplate="header">
    <div class="complaint-modal-header">
      <span class="complaint-modal-title">Customer Complaint</span>
      <span class="complaint-modal-subtitle">We'll get back to you as soon as possible.</span>
    </div>
  </ng-template>

  <form [formGroup]="form" class="complaint-modal-content" (ngSubmit)="onSubmit()">
    <div class="form-field">
      <label for="complaint-name">Name</label>
      <input id="complaint-name" type="text" class="form-control" [value]="studentName" readonly />
    </div>

    <div class="form-field">
      <label for="complaint-email">Email Address</label>
      <input id="complaint-email" type="email" class="form-control" [value]="studentEmail" readonly />
    </div>

    <div class="form-field">
      <label for="complaint-category">Complaint Category <span class="required">*</span></label>
      <p-select
        inputId="complaint-category"
        formControlName="categoryId"
        [options]="categoryOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Select a category"
        styleClass="status-select form-control-bg"
        panelStyleClass="student-portal-overlay"
        [appendTo]="'body'">
      </p-select>
      @if (form.controls.categoryId.touched && form.controls.categoryId.invalid) {
        <span class="field-error">Please select a category.</span>
      }
    </div>

    <div class="form-field">
      <label for="complaint-description">Description <span class="required">*</span></label>
      <textarea
        id="complaint-description"
        formControlName="description"
        class="form-control complaint-description"
        rows="5"
        maxlength="2000"
        placeholder="Please provide details about your issue..."
        [readonly]="isStaffPortalPreview"></textarea>
      @if (form.controls.description.touched && form.controls.description.invalid) {
        <span class="field-error">Please describe your issue.</span>
      }
    </div>

    <div class="form-field">
      <label>Attachment (optional)</label>
      <div class="file-upload-wrapper">
        <div class="file-upload-area" [class.disabled]="isStaffPortalPreview">
          <input
            #fileInput
            type="file"
            id="complaint-attachment"
            class="file-input"
            accept="image/*,.pdf,.doc,.docx"
            (change)="onFileSelected($event)"
            [disabled]="isStaffPortalPreview" />
          <div class="file-upload-placeholder">
            <span>Drag and drop file here or click</span>
          </div>
          <button
            type="button"
            class="browse-btn"
            (click)="fileInput.click()"
            [disabled]="isStaffPortalPreview">
            Browse
          </button>
        </div>
        @if (selectedFile) {
          <div class="uploaded-file-row">
            <img [src]="fileIcon" alt="" class="file-type-icon" />
            <div class="file-meta">
              <div class="file-title">{{ selectedFile.name }}</div>
              <div class="file-size">{{ fileSizeLabel }}</div>
            </div>
            <div class="file-actions">
              <button
                type="button"
                class="view-file-btn"
                (click)="viewFile($event)"
                [attr.title]="isDocOrDocx ? 'Download file' : 'View file'">
                <img
                  [src]="isDocOrDocx ? downloadIcon : eyeIcon"
                  [alt]="isDocOrDocx ? 'Download' : 'View'"
                  class="view-icon" />
              </button>
              <button
                type="button"
                class="cancel-file-btn"
                (click)="removeFile($event)"
                [disabled]="isStaffPortalPreview"
                aria-label="Remove file">
                <img [src]="cancelIcon" alt="Remove" class="cancel-icon" />
              </button>
            </div>
          </div>
        }
      </div>
    </div>

    <p class="legal-note">
      By submitting this form, you agree to our
      <a [href]="privacyPolicyRoute" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
    </p>
  </form>

  <ng-template pTemplate="footer">
    <div class="complaint-modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="onSubmit()"
        [disabled]="isSubmitting || isStaffPortalPreview"
        [attr.title]="isStaffPortalPreview ? studentOnlyAccessMessage : null">
        Submit
      </button>
    </div>
  </ng-template>
</p-dialog>

<app-pdf-viewer-modal
  [(visible)]="pdfViewerVisible"
  [pdfUrl]="pdfViewerUrl"
  [documentName]="pdfViewerDocumentName"
  (onClose)="onClosePdfViewer()">
</app-pdf-viewer-modal>
